import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function TimePickerComponent({
  time,
  onTimeChange,
  minTime,
  maxTime,
}) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="flex flex-col items-start relative space-y-4">
      {/* Button to Open Time Picker */}
      <button
        onClick={() => setIsOpen(true)}
        className="p-3 bg-[#F4F4F4] text-sm flex items-center justify-between md:min-w-[140px] min-w-[120px] w-full text-primary-text md:texr-base rounded-[10px] "
      >
        {time
          ? time.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "Time"}
        <div className="w-[24px] h-[22px]">
          <i className="fi fi-rs-angle-small-down text-[#5D5D5D] text-xl leading-none"></i>
        </div>
      </button>

      {/* Time Picker Component */}
      {isOpen && (
        <DatePicker
          selected={time}
          onChange={(selectedTime) => {
            onTimeChange(selectedTime); // Update the time
            setIsOpen(false); // Close picker after selection
          }}
          onClickOutside={() => setIsOpen(false)} // Close on outside click
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15} // Select time in 15-minute intervals
          timeCaption="Time"
          dateFormat="h:mm aa" // 12-hour format
          inline // Show picker inline
          minTime={minTime} // Disable times before minTime
          maxTime={maxTime} // Disable times after maxTime
        />
      )}
    </div>
  );
}
